import { validateInputs } from 'shared/lib';
import { TLoginState, LoginTypes } from '../types/types';

export const classificationLogin = (login: TLoginState): TLoginState => {
  const trimmed = login.value.trim();

  if (validateInputs.validateMail(trimmed)) {
    return { type: LoginTypes.EMAIL, value: trimmed };
  }

  let phone = trimmed.replace(/[^+\d]/g, '').replace(/^\+/, '');
  phone = phone.replace(/^8/, () => '7');

  if (validateInputs.validatePhone(phone)) {
    return { type: LoginTypes.PHONE, value: phone };
  }
  return { type: false, value: trimmed };
};
